import { Component, inject, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Observable } from 'rxjs';
import { PageResult } from '@shared/components/classes/page-result';
import { BasicTableComponent } from '@common/references/basic-table.component';
import { SharedModule } from '@primeng/api';
import { Table } from '@primeng/table';
import { TranslatePipe } from '@ngx-translate/core';
import { ReadingService } from '@modules/universal-billing/reading/reading.service';
import { ReferenceField } from '@common/references/reference-field';
import { Reading } from '@modules/universal-billing/reading/reading.interfaces';

@Component({
  selector: 'apartment-readings',
  standalone: true,
  imports: [
    SharedModule,
    Table,
    TranslatePipe
  ],
  templateUrl: './apartment-readings.component.html',
  styleUrls: ['./apartment-readings.component.scss']
})
export class ApartmentReadingsComponent extends BasicTableComponent<any> {
  @Input() apartmentId: number;
  @Input() period: Date;

  service = inject(ReadingService);
  addQueryToUrl = false;

  fields: ReferenceField[] = [];

  constructor() {
    super();
    this.fields = this.service.fields.map(field => ({
      ...field,
      filter: false,
    }));
  }

  getAll(params: any): Observable<PageResult<Reading>> {

    params.apartmentId = this.apartmentId;
    params.period = this.period;
    params.orderType = 'desc';

    return super.getAll(params);
  }

}
